<form [formGroup]="profileForm" class="catalog-masterdata no-field-space">

  <sc-flex >
    <app-dictionary-entry-label  [model]="catalog?.name">
    </app-dictionary-entry-label>
    <sc-content-spacer grow></sc-content-spacer>
      <button mat-icon-button (click)="changeCatalogTitle()">
          <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button  [disabled]="!downloadEnabled" (click)="exportCatalogArticles()">
        <mat-icon><sc-icon iconClass="fa-download"></sc-icon></mat-icon>
        <sc-dictionary-label dictionaryKey="erp.ui.catalog.action.download-articles"></sc-dictionary-label>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button (click)="importCostsPrices()">
        <mat-icon><sc-icon iconClass="fa-upload"></sc-icon></mat-icon>
        <sc-dictionary-label dictionaryKey="erp.ui.catalog.action.import-costsprices"></sc-dictionary-label>
      </button>
  </sc-flex>
</form>
